export enum UtilValue {
  sumup = "sumup",
  single = "single",
  all = "all",
}
